import { GET_URL } from '@utils/api/endpoints.ts';
import { Axios } from '@utils/api/axios-instance.ts';
import { useQuery } from 'react-query';
import {
  Organization,
  OrganizationResponse
} from '@utils/types/organization/organization.ts';
import { TokenExtension } from '@utils/extensions/token.extension.ts';
import { IS_ON_PREM } from '@utils/constants/app-constants.ts';

export async function fetchOrganization(): Promise<Organization> {
  const { data } = await Axios.get<OrganizationResponse>(
    GET_URL().organization
  );
  return data.result;
}

export function useOrganization() {
  return useQuery<Organization>(['organization'], fetchOrganization, {
    // Disable in on-prem mode since /api/v3/account/organization doesn't exist
    enabled: !!TokenExtension.get()?.string && !IS_ON_PREM,
    useErrorBoundary: false,

    // Reasonable defaults
    staleTime: 1000 * 60 * 15, // 5 minutes
    cacheTime: 1000 * 60 * 30, // 30 minutes

    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false
  });
}
